import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationService } from '@services/authentication/authentication.service';
// import { currentId } from 'async_hooks';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // add authorization header with jwt token if available
    const currentUser = this.authService.currentUser;
    // console.log('JwtInterceptor: Inspecting: {0}', currentUser);
    //console.log('Request: Inspecting:', request);
    if (currentUser?.token && !request.url.startsWith('https://') && !request.url.startsWith('http://')) {
      //console.log('JwtInterceptor: Attaching Token to', request);
      request = request.clone({
        headers: request.headers.append('Authorization', 'Bearer ' + currentUser.token)
      });
    } else {
      // console.log('JwtInterceptor: No Token to attach');
    }

    return next.handle(request);
  }
}
